import { useEffect, useState } from 'react';
import { CardBoxContainer, CardGrid } from './styled';
import TopicCard from './TopicCard';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function TopicListingSearchResults(props) {
  const { cardData } = props;
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });
  useEffect(() => {
    if (cardData) {
      let cardIds = '';
      cardData?.map((element, index) => {
        let id = element?.term_id;
        index == 0 ? (cardIds = id) : (cardIds = cardIds + ',' + id);
      });
      fireServedSectionEvent('Search Results', cardIds, 'Topics List');
    }
  }, []);
  return (
    <>
      <CardGrid>
        {cardData?.map((data, index) => {
          return (
            <CardBoxContainer key={`topic_${index}`}>
              <TopicCard
                setGridCardSignal={setGridCardSignal}
                gridCardSignal={gridCardSignal}
                itemIndex={index}
                title={'Search Results'}
                data={data}
              />
            </CardBoxContainer>
          );
        })}
      </CardGrid>
    </>
  );
}
